import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Form, Input, Select, Button } from "antd";
import type { FormInstance } from "antd";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { useServiceList } from "@src/hooks/api/service/hooks";
import { ServiceItem } from "../../../types/api/service";

interface OurServicesData {
  heading?: string;
  subtext?: string;
  selectedServices?: string[];
}

interface Props {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: FormInstance;
  ourServicesData?: OurServicesData;
  serviceList?: ServiceItem[];
  loading?: boolean;
}

const OurServicesSection: React.FC<Props> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  ourServicesData,
  serviceList,
  loading,
}) => {
  useEffect(() => {
    if (ourServicesData) {
      form.setFieldsValue({
        ourServices: {
          heading: ourServicesData.heading || "",
          subtext: ourServicesData.subtext || "",
          selectedServices:
            ourServicesData.selectedServices?.map((s: any) => s._id) || [],
        },
      });
    } else {
      form.setFieldsValue({
        ourServices: {
          heading: "",
          subtext: "",
          selectedServices: [],
        },
      });
    }
  }, [ourServicesData, form]);


  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden">
            <table className="hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>

              <tbody>
                {ourServicesData ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4 ">
                      {ourServicesData.heading}
                    </td>
                    <td className="py-3 px-4 ">
                      {ourServicesData.subtext}
                    </td>
                    <td className="py-3 px-4 text-right text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="bg-[#F9F9F9] border-b sm:block hidden">
              <div className="py-3 px-4">
                <Form layout="vertical" form={form}>
                  <Form.Item
                    label="Select Services"
                    name={["ourServices", "selectedServices"]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select services"
                      options={serviceList?.map((service) => ({
                        label: service.heading,
                        value: service._id,
                      }))}
                    />
                  </Form.Item>
                </Form>

                <ButtonWrapper
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                >
                  Save
                </ButtonWrapper>
              </div>
            </div>
          </div>

          <div className="sm:hidden block">
            {ourServicesData ? (
              <div className="bg-[#F9F9F9] border rounded-lg mb-4 p-4 space-y-3">
                <p>
                  <b className="text-primary">Heading:</b> <div>{ourServicesData?.heading}</div>
                </p>
                <p>
                  <b className="text-primary">Subtext:</b> <div>{ourServicesData?.subtext}</div>
                </p>

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[20px] text-primary"
                />
              </div>
            ) : (
              <div className="text-center py-6">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}

            <div className="bg-[#F9F9F9] border rounded-lg">
              <div className="py-3 px-4">
                <Form layout="vertical" form={form}>
                  <Form.Item
                    label="Select Services"
                    name={["ourServices", "selectedServices"]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select services"
                      options={serviceList?.map((service) => ({
                        label: service?.heading,
                        value: service?._id,
                      }))}
                    />
                  </Form.Item>
                </Form>

                <ButtonWrapper
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                >
                  Save
                </ButtonWrapper>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 rounded-lg">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["ourServices", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Heading" />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["ourServices", "subtext"]}
                rules={[{ required: true, message: "Please enter subtext" }]}
              >
                <TextArea rows={3} placeholder="Subtext" />
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>

            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurServicesSection;
